import * as React from 'react';
import { useTranslation } from 'next-i18next';

import { getServerTranslations } from '../../../get-server-side-translations';
import { EmployerSecondaryLayout } from '../../../layouts';
import UserSettingsComponent from '../../../components/user-settings';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface ISettingsPageProps {}

const SettingsPage: React.FunctionComponent<ISettingsPageProps> = (props) => {
  const { t } = useTranslation('user-settings');
  return (
    <EmployerSecondaryLayout title={t('user-settings-title')}>
      <UserSettingsComponent />
    </EmployerSecondaryLayout>
  );
};

export default SettingsPage;
export const getStaticProps = async ({ locale }) => {
  const transConfig = await getServerTranslations(locale, ['common', 'user-settings']);
  return {
    props: {
      ...transConfig,
    },
  };
};
